"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/*:: import { type CSS, type ThemeType } from '../../style/ThemeTypes';*/
var MARGIN = 1;
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    '@keyframes rotate': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    spinner: {
      display: 'inline-block',
      margin: theme.functions.toRem(MARGIN),
      width: theme.functions.toRem(parseInt(theme.variables.icon) - MARGIN * 2),
      height: theme.functions.toRem(parseInt(theme.variables.icon) - MARGIN * 2),
      animation: '$rotate 1.1s infinite linear',
      borderRadius: '50%',
      borderWidth: '.125rem',
      borderStyle: 'solid',
      borderTopColor: 'transparent',
      borderRightColor: 'inherit',
      borderBottomColor: 'transparent',
      borderLeftColor: 'inherit',
      backgroundColor: 'transparent'
    }
  };
});
/*:: type Props = {
  className?: string,
  style?: CSS
};*/
var Spinner = function Spinner(_ref /*:: */) {
  var className = _ref /*:: */.className,
    style = _ref /*:: */.style;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames.default)(classes.spinner, className),
    style: style
  });
};
Spinner.displayName = 'Spinner';
var _default = exports.default = Spinner;
//# sourceMappingURL=Spinner.js.map